var chunkMapping = {
	"30": [
		16030
	],
	"120": [
		97120
	],
	"153": [
		82153
	],
	"186": [
		23186
	],
	"327": [
		88327
	],
	"414": [
		85414
	],
	"467": [
		2467
	],
	"468": [
		30468
	],
	"571": [
		37571
	],
	"590": [
		5590
	],
	"772": [
		51772
	],
	"784": [
		3784
	],
	"832": [
		59832
	],
	"836": [
		31836
	],
	"960": [
		27960
	]
};
var idToExternalAndNameMapping = {
	"2467": [
		"default",
		"./RiskChart",
		134
	],
	"3784": [
		"default",
		"./FrontendAnalytics",
		134
	],
	"5590": [
		"default",
		"./CustomerListStandAlone",
		85712
	],
	"16030": [
		"default",
		"./FrontendAI",
		13025
	],
	"23186": [
		"default",
		"./LinkAnalysis",
		134
	],
	"27960": [
		"default",
		"./Homepage",
		134
	],
	"30468": [
		"default",
		"./FrontendLookups",
		85712
	],
	"31836": [
		"default",
		"./IdentityPage",
		85712
	],
	"37571": [
		"default",
		"./LoginTableStandAlone",
		85712
	],
	"51772": [
		"default",
		"./ExportsList",
		85712
	],
	"59832": [
		"default",
		"./BotDetectionTableStandAlone",
		85712
	],
	"82153": [
		"default",
		"./Alerts",
		134
	],
	"85414": [
		"default",
		"./RuleEngine",
		88463
	],
	"88327": [
		"default",
		"./ImportsList",
		85712
	],
	"97120": [
		"default",
		"./FrontendCustomerDetail",
		1369
	]
};
var idToRemoteMap = {
	"2467": [
		{
			"externalType": "script",
			"name": "FrontendAnalytics"
		}
	],
	"3784": [
		{
			"externalType": "script",
			"name": "FrontendAnalytics"
		}
	],
	"5590": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"16030": [
		{
			"externalType": "script",
			"name": "FrontendAI"
		}
	],
	"23186": [
		{
			"externalType": "script",
			"name": "FrontendAnalytics"
		}
	],
	"27960": [
		{
			"externalType": "script",
			"name": "FrontendAnalytics"
		}
	],
	"30468": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"31836": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"37571": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"51772": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"59832": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"82153": [
		{
			"externalType": "script",
			"name": "FrontendAnalytics"
		}
	],
	"85414": [
		{
			"externalType": "script",
			"name": "RuleEngine"
		}
	],
	"88327": [
		{
			"externalType": "script",
			"name": "FrontendLookups"
		}
	],
	"97120": [
		{
			"externalType": "script",
			"name": "FrontendCustomerDetail"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"2467": {
		"shareScope": "default",
		"name": "./RiskChart",
		"externalModuleId": 134,
		"remoteName": "FrontendAnalytics"
	},
	"3784": {
		"shareScope": "default",
		"name": "./FrontendAnalytics",
		"externalModuleId": 134,
		"remoteName": "FrontendAnalytics"
	},
	"5590": {
		"shareScope": "default",
		"name": "./CustomerListStandAlone",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"16030": {
		"shareScope": "default",
		"name": "./FrontendAI",
		"externalModuleId": 13025,
		"remoteName": "FrontendAI"
	},
	"23186": {
		"shareScope": "default",
		"name": "./LinkAnalysis",
		"externalModuleId": 134,
		"remoteName": "FrontendAnalytics"
	},
	"27960": {
		"shareScope": "default",
		"name": "./Homepage",
		"externalModuleId": 134,
		"remoteName": "FrontendAnalytics"
	},
	"30468": {
		"shareScope": "default",
		"name": "./FrontendLookups",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"31836": {
		"shareScope": "default",
		"name": "./IdentityPage",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"37571": {
		"shareScope": "default",
		"name": "./LoginTableStandAlone",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"51772": {
		"shareScope": "default",
		"name": "./ExportsList",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"59832": {
		"shareScope": "default",
		"name": "./BotDetectionTableStandAlone",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"82153": {
		"shareScope": "default",
		"name": "./Alerts",
		"externalModuleId": 134,
		"remoteName": "FrontendAnalytics"
	},
	"85414": {
		"shareScope": "default",
		"name": "./RuleEngine",
		"externalModuleId": 88463,
		"remoteName": "RuleEngine"
	},
	"88327": {
		"shareScope": "default",
		"name": "./ImportsList",
		"externalModuleId": 85712,
		"remoteName": "FrontendLookups"
	},
	"97120": {
		"shareScope": "default",
		"name": "./FrontendCustomerDetail",
		"externalModuleId": 1369,
		"remoteName": "FrontendCustomerDetail"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}